import * as React from 'react';

function SvgIconFileImage(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M24.2 27.467H7.133A2.133 2.133 0 015 25.333v-19.2A2.133 2.133 0 017.133 4H24.2a2.133 2.133 0 012.133 2.133v19.2a2.133 2.133 0 01-2.133 2.134z"
        stroke="#535B64"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.921 19.415l-3-6a.749.749 0 00-1.256-.134l-2.571 3.213-1.678-1.118a.753.753 0 00-1.059.238l-2.25 3.75a.75.75 0 00.643 1.136h10.5a.75.75 0 00.671-1.085zM14.5 13a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill="#535B64"
      />
    </svg>
  );
}

export const IconFileImage = React.memo(SvgIconFileImage);
